import { Divider, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { ExamDateDto } from "api";
import { CelebrationIcon, Header } from "components";
import { formatDate } from "utils";

export const ConfirmationNotStartedPayment = ({
  examDetails,
  paymentDeadline,
}: {
  examDetails?: ExamDateDto;
  paymentDeadline?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: 2 }}>
      <Header
        title={t("confirmation.notStarted.headerTitle", {
          examName: examDetails?.examName,
        })}
        subtitle={t("confirmation.notStarted.subtitle")}
        icon={<CelebrationIcon />}
      />
      <Typography>
        <Trans
          i18nKey="payment.deadline"
          values={{ date: formatDate(paymentDeadline) }}
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>{t("confirmation.confirmationEmailSent")}</Typography>
      <Typography>
        <Trans
          i18nKey="confirmation.examScheduleNotice"
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>{t("confirmation.oralExamNote")}</Typography>
      <Typography sx={{ color: "text.secondary" }}>
        {t("confirmation.notStarted.autoRedirect")}
      </Typography>
      <Divider />
      <Typography>{t("confirmation.thankYou")}</Typography>
    </Stack>
  );
};
